import api from '@/utils/api';

export const QueryUserAllList = () => {
    return api.post(``);
};

export const QueryAreaAuthTree = data => {
    return api.post(`/component/getComponentAreaRegionTreeByDataAuthority`, data);
};

export const QueryDictData = data => {
    return api.post(`/component/getComponentDictDictionaryList`, data);
};
